var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Upload',{staticClass:"upload-demo",attrs:{"action":"https://jsonplaceholder.typicode.com/posts/","on-preview":_vm.handlePreview,"on-remove":_vm.handleRemove,"before-remove":_vm.beforeRemove,"multiple":"","limit":3,"on-exceed":_vm.handleExceed}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }